import { render, staticRenderFns } from "./BlockProjects.vue?vue&type=template&id=04c15e9e"
import script from "./BlockProjects.vue?vue&type=script&lang=js"
export * from "./BlockProjects.vue?vue&type=script&lang=js"
import style0 from "./BlockProjects.vue?vue&type=style&index=0&id=04c15e9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports